const downloader = document.createElement('a');
function downloadFile(blob, filename) {
    const url = URL.createObjectURL(blob);
    downloader.href = url;
    downloader.setAttribute('download', filename);
    downloader.click();
    URL.revokeObjectURL(url);
}
export default downloadFile;
